/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/ResourceLocation/Form
 * @desc Filter ResourceLocation form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import {
  PostFilterComparison,
  PostFilterOperator,
} from 'labstep-web/services/postFilter/constants';
import { getPostFilterResourceLocation } from 'labstep-web/services/postFilter/filters/resourceLocation';
import type React from 'react';
import type { IFilterPostReportResourceLocationFormProps } from './types';

const FilterPostReportResourceLocationForm: React.FC<
  IFilterPostReportResourceLocationFormProps
> = ({
  addPostFilter,
  onDone,
  activeGroup,
  path,
  protocolValueName,
}) => {
  if (!activeGroup) {
    return null;
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        entityName={ResourceLocation.entityName}
        isClearable
        params={{
          group_id: activeGroup?.id,
        }}
        onChange={(selectedOption) => {
          if (addPostFilter) {
            if (protocolValueName) {
              const complexFilterNode = {
                type: PostFilterOperator.and,
                path: 'protocolValues',
                predicates: [
                  {
                    attribute: 'name',
                    comparison: PostFilterComparison.eq,
                    value: protocolValueName,
                  },
                  getPostFilterResourceLocation(path).getNode([
                    selectedOption?.guid,
                  ]),
                ],
              };

              addPostFilter(complexFilterNode as any);
            } else {
              addPostFilter(
                getPostFilterResourceLocation(path).getNode([
                  selectedOption?.guid,
                ]),
              );
            }
          }
          onDone();
        }}
      />
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(FilterPostReportResourceLocationForm);
